import styled from 'styled-components'
import { backgroundOrange, darkOrange, black, textMuted, darkGrey } from '@/theme/colors'
import { radii, media } from '@/theme/tokens'
import { text, tracking } from '@/theme/typography'
import { Button } from '@components/Button'

export const LinkRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	background: ${backgroundOrange};
	border-radius: ${radii.inner};
	padding: 11px 14px;

	${media.phone} {
		flex-wrap: wrap;
	}
`

export const LinkIconSlot = styled.span`
	display: inline-flex;
	align-items: center;
	color: ${darkOrange};
	flex-shrink: 0;
`

export const LinkText = styled.span`
	flex: 1 1 160px;
	min-width: 0;
	${text.bodySm}
	color: ${textMuted};
	overflow-wrap: anywhere;
`

export const CopyLinkButton = styled(Button)`
	flex-shrink: 0;
`

export const CodeLine = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px;
	margin-top: 14px;
	${text.bodyXs}
	color: ${textMuted};
`

export const CodeValue = styled.span`
	${text.labelSm}
	color: ${black};
	letter-spacing: ${tracking.wide};
`

export const CopyCodeButton = styled(Button).attrs({ variant: 'icon' as const })`
	width: 28px;
	height: 28px;
	color: ${darkOrange};
`

/** The transient "Copied" confirmation beside the code — calm, no motion. */
export const CopiedNote = styled.span`
	${text.labelSm}
	color: ${darkOrange};
`

export const InviteFootnote = styled.p`
	margin: 14px 0 0;
	${text.caption}
	color: ${darkGrey};
`
